import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '@/shared/store/store';
import {
  fetchTenantAsync,
  updateTenantAsync,
} from '@/shared/store/slices/tenant-slice';
import { Tenant } from '@/shared/types';

export const useTenant = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { currentTenant, subdomain, loading, error } = useSelector(
    (state: RootState) => state.tenant
  );

  const fetchTenant = (subdomain: string) => {
    return dispatch(fetchTenantAsync(subdomain));
  };

  const updateTenant = (tenantData: Partial<Tenant>) => {
    return dispatch(updateTenantAsync(tenantData));
  };

  return {
    currentTenant,
    subdomain,
    loading,
    error,
    fetchTenant,
    updateTenant,
  };
};
